__turbopack_context__.v({
  "archidekt": "_SfoXa_archidekt",
  "battlefield": "_SfoXa_battlefield",
  "card": "_SfoXa_card",
  "commandZone": "_SfoXa_commandZone",
  "exile": "_SfoXa_exile",
  "graveyard": "_SfoXa_graveyard",
  "hand": "_SfoXa_hand",
  "icon": "_SfoXa_icon",
  "library": "_SfoXa_library",
});
